import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import { OfwcaPathTypes } from './ofwcaPath.actions';
import {
  fetchFormData,
  fetchRelatedStations,
  fetchSignedDocuments,
  finishForm,
  generateToken,
  sendAnswers,
  uploadFile,
  verifyToken,
  downloadResource,
} from './ofwcaPath.sagas';

export function* watchOfwcaPath() {
  yield all([
    // TODO: Change Reduxsauce for sth else, it cannot work with Typescript
    yield takeLatest(OfwcaPathTypes.FETCH_FORM_DATA, fetchFormData),
    yield takeLatest(OfwcaPathTypes.FETCH_RELATED_STATIONS, fetchRelatedStations),
    yield takeLatest(OfwcaPathTypes.SEND_ANSWERS, sendAnswers),
    yield takeLatest(OfwcaPathTypes.GENERATE_TOKEN, generateToken),
    yield takeLatest(OfwcaPathTypes.VERIFY_TOKEN, verifyToken),
    yield takeEvery(OfwcaPathTypes.UPLOAD_FILE, uploadFile),
    yield takeLatest(OfwcaPathTypes.FETCH_SIGNED_DOCUMENTS, fetchSignedDocuments),
    yield takeLatest(OfwcaPathTypes.FINISH_FORM, finishForm),
    yield takeLatest(OfwcaPathTypes.DOWNLOAD_RESOURCE, downloadResource),
  ]);
}
